import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ButtonLink } from '../components/ButtonLink/ButtonLink';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const Error404 = () => {
    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return (
        <Box textAlign="center" mt={8}>
            <Typography variant="h2">{translations.ERROR_404_TITLE}</Typography>
            <Typography variant="subtitle1" gutterBottom>
                {translations.ERROR_404}
            </Typography>

            <Box mt={8}>
                <ButtonLink to="/" text={translations.GLOBAL_HOME_BUTTON} />
            </Box>
        </Box>
    );
};
